import React from 'react';
import { Link } from 'react-router-dom';
// import countriesAndStates from '../../testing/countriesAndStates';
import { initializeFormValidation, validForm } from '../../../helpers/forms/form-validation';
import initializeLocations from '../../../helpers/forms/location-form';
import signUpInitiate from '../../../helpers/forms/sign-up';
import initializeAutosubmit from '../../../helpers/forms/autosubmit';
import initializeTextAreaSubmit from '../../../helpers/forms/textarea-submit';
import initializeSubmissionPrevention from '../../../helpers/forms/prevent-submit';
// import locationData from '../../testing/locationData';
import customRequest from '../../../helpers/customRequest';
import message from '../../../components/message/message';
import redirect from '../../../components/redirect/redirect';
import ClipLoader from "react-spinners/ClipLoader";
import ReactGA from 'react-ga'

class SignUp extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			name: "",
			username: "",
			"email-address": "",
			password: "",
			"password-confirmation": "",
			referral: "",
			entity: "",
			role: "",
			address: "",
			city: "",
			country: "",
			state: "",
			"postal-code": "",
			phone: "",
			fax: "",
			"agree-policy": false,
			role: "",

			loading: false,
			postalCodeRequestTimeout: null,
			countriesOptions: []
		}
	}

	componentDidMount() {

		customRequest.get("/api/countries")
		.then(({data}) =>
		{
			this.setState({
				countriesOptions: data.countries
			}, () => {
				// initialize scripts for form
				initializeLocations();
				initializeFormValidation();
	
				initializeAutosubmit();
				initializeTextAreaSubmit();
				initializeSubmissionPrevention();
	
				signUpInitiate();
			});
		})
	}

	handleInputChange = (event) => {
		const target = event.target;
		const name = target.name;

		let value;
		if (target.type === "checkbox") {
			value = target.checked;
		} else if (target.type === "number") {
			value = parseInt(target.value, 10);
		} else {
			value = target.value;
		}

		this.setState({ [name]: value }, () => {
			if (target.name === "postal-code") {
				clearTimeout(this.state.postalCodeRequestTimeout);
				this.setState({
					postalCodeRequestTimeout: setTimeout(this.setLocationInfo, 1000)
				});
			}
		});
	}

	setLocationInfo = async () => {
		let zipcodeResponse = await customRequest.get("/api/zipcode?zipcode=" + this.state["postal-code"])
		let locationDataResponse = zipcodeResponse.data
		
		if (locationDataResponse.valid === false) {
			return
		}

		document.getElementById("state-autofill").value = locationDataResponse.state

		this.setState({
			city: locationDataResponse.city,
		}, () => {
			let event = new Event('blur', { bubbles: true });
			document.getElementById("city").dispatchEvent(event);
		});

		this.setState({
			country: locationDataResponse.country
		}, () => {
			let event = new Event('blur', { bubbles: true });
			document.getElementById("country").dispatchEvent(event);
		});

		document.getElementById("country").addEventListener("blur", (event) => {
			event.target.removeEventListener(event.type, this);
			this.setState({
				state: locationDataResponse.state
			});
		});
	}

	submitForm = (event) => {
		let page = this
		event.preventDefault()
		message.clear()

		var signUpForm = document.getElementById("sign-up-form");
		var blurEvent = document.createEvent("Event");
		blurEvent.initEvent("blur", false, true);
		blurEvent.submission = false;
		blurEvent.showFeedback = false;
		
		if (validForm(signUpForm, blurEvent) == false) {
			return
		}

		this.setState({loading: true}, () =>
		{

			if (!this.state['agree-policy']) {
				page.setState({loading: false})
				return message.error("You must agree to the Terms of Use and Privacy Policy.")
			}
			
			customRequest.post("/api/sign-up", {
				name: this.state.name,
				username: this.state.username,
				emailAddress: this.state['email-address'],
				password: this.state.password,
				referral: this.state.referral,
				entity: this.state.entity,
				city: this.state.city,
				country: this.state.country,
				state: this.state.state,
				postalCode: this.state['postal-code'],
				phoneNumber: this.state.phone,
				role: this.state.role
			})
			.then(({data}) =>
			{
				if (!data.valid) {
					this.setState({loading: false})
					return message.error(data.message)
				}
				
				ReactGA.event({
					category: 'digitalSignUp',
					action: 'click',
					label: 'button'
				  })
				this.props.updatePermissions()
				.then(() => {
					redirect.send("/account/sign-up/success")
				})
			})
		})
	}

	render() {

		return (
			<React.Fragment>
				<h1>Sign Up to Get Started with GreatLeaps</h1>

				<div class="row subheader-text">
					<div class="col-sm-10 offset-sm-1 col-md-8 offset-md-2">
						<p>Fill out this form with your information, click the "Create Account" Button, and activate your account by following the instructions we send to your email address.</p>

						<h4><strong>All new accounts come with a 14-day free trial. Register up to 10 students and get started!</strong></h4>
					</div>
				</div>

				<form id="sign-up-form" class="form-horizontal form-validate" noValidate method="post" onSubmit={this.submitForm}>
					<div class="form-group row">
						<label for="name" class="d-none d-sm-inline col-sm-3 control-label text-right">Name</label>

						<div class="col-sm-6">
							
							<div class = "input-group">
								<input type="text" class="form-control" disabled={this.state.loading} id="name" name="name" value={this.state.name} onChange={this.handleInputChange} placeholder="Name" required data-description="enter a name" autofocus />

                                
                                <span class = "input-group-text">First and Last</span>
                            </div>
						
						</div>
					</div>

					<div class="form-group row">
						<label for="username" class="d-none d-sm-inline col-sm-3 control-label text-right">Username</label>

						<div class="col-sm-6">
							<input type="text" class="form-control unique" disabled={this.state.loading} id="username" name="username" value={this.state.username} onChange={this.handleInputChange} placeholder="Username (make short and simple)" required data-description="enter a username" />
						</div>
					</div>

					<div class="form-group row">
						<label for="email-address" class="d-none d-sm-inline col-sm-3 control-label text-right">Email&nbsp;Address</label>

						<div class="col-sm-6">
							<input type="email" class="form-control unique" disabled={this.state.loading} id="email-address" name="email-address" value={this.state["email-address"]} onChange={this.handleInputChange} placeholder="Email Address" required data-description="enter an email address" />
						</div>
					</div>

					<div class="form-group row">
						<label for="password" class="d-none d-sm-inline col-sm-3 control-label text-right">Password</label>

						<div class="col-sm-6">
							<input type="password" class="form-control string" disabled={this.state.loading} id="password" name="password" value={this.state.password} onChange={this.handleInputChange} placeholder="Password" required data-type="password" minlength="5" data-description="enter a password" />
						</div>
					</div>

					<div class="form-group row">
						<label for="password-confirmation" class="d-none d-sm-inline col-sm-3 control-label text-right">Confirm&nbsp;Password</label>

						<div class="col-sm-6">
							<input type="password" class="form-control confirmation" disabled={this.state.loading} id="password-confirmation" name="password-confirmation" value={this.state["password-confirmation"]} onChange={this.handleInputChange} placeholder="Confirm Password" required data-type="passwords" data-confirms="password" data-description="confirm your password" />
						</div>
					</div>

					<div class="form-group row">
						<label for="referral" class="d-none d-sm-inline col-sm-3 control-label text-right">How did you hear about us?</label>

						<div class="col-sm-6">
							<div class="input-group">
								<select class="form-control" disabled={this.state.loading} name="referral" id="referral" value={this.state.referral} onChange={this.handleInputChange} data-description="select a referral">
									<option value="" disabled selected>Referral:</option>
									<option value="Web">Web</option>
									<option value="Conference">Conference</option>
									<option value="Social Media" >Social Media</option>
									<option value="School">School</option>
									<option value="SEEN Magazine/Email">SEEN Magazine/Email</option>
									<option value="Other">Other</option>
								</select>
								<span class="input-group-text">optional</span>
							</div>
						</div>
					</div>

					<div class="form-group row">
						<label for="entity" class="d-none d-sm-inline col-sm-3 control-label text-right">School/Company/Entity</label>

						<div class="col-sm-6">
							<div class="input-group">
								<input type="text" class="form-control string" disabled={this.state.loading} name="entity" id="entity" value={this.state.entity} onChange={this.handleInputChange} placeholder="School/Company/Entity" maxlength="175" data-type="entity" data-description="enter a School/Company/Entity" />

								<span class="input-group-text">optional</span>
							</div>
						</div>
					</div>

					<div class="form-group row">
						<label for="role" class="d-none d-sm-inline col-sm-3 control-label text-right">Role</label>

						<div class="col-sm-6">
							<select class="form-control" disabled={this.state.loading} name="role" id="role" required value={this.state.role} onChange={this.handleInputChange} data-description="select a role">
								<option value="" disabled selected>Role:</option>
								{
									["Parent", "Tutor", "Teacher", "Administrator", "Other"].map((role) =>
									{
										return <option value={role}>{role}</option>
									})
								}
							</select>
						</div>
					</div>

					<div class="form-group row">
						<label for="postal-code" class="d-none d-sm-inline col-sm-3 control-label text-right">Postal Code</label>

						<div class="col-sm-6">
							<input type="text" class="form-control string" disabled={this.state.loading} name="postal-code" id="postal-code" value={this.state["postal-code"]} onChange={this.handleInputChange} required placeholder="Postal Code" maxlength="175" data-type="postal code" data-description="enter a postal code" />
						</div>
					</div>

					<div class="form-group row">
						<label for="city" class="d-none d-sm-inline col-sm-3 control-label text-right">City</label>

						<div class="col-sm-6">
							<input type="text" class="form-control string" disabled={this.state.loading} name="city" id="city" value={this.state.city} onChange={this.handleInputChange} placeholder="City" maxlength="175" data-type="city" data-description="enter a city" required />
						</div>
					</div>

					<div class="form-group row">
						<label for="country" class="d-none d-sm-inline col-sm-3 control-label text-right">Country</label>

						<div class="col-sm-6">
							<select class="form-control" disabled={this.state.loading} name="country" id="country" onChange={this.handleInputChange} value={this.state.country} required data-description="select a country">
								<option value="" disabled selected>Country:</option>
								{this.state.countriesOptions.map((item) => {
									return (<option value={item}>{item}</option>)
								})}
							</select>
						</div>
					</div>

					<div class="state-autofill-target">
						<input type="text" name="state-autofill" id="state-autofill"/>
					</div>

					<div class="form-group row">
						<label for="state" class="d-none d-sm-inline col-sm-3 control-label text-right">State or Province</label>

						<div class="col-sm-6">
							<select class="form-control" disabled={this.state.loading} name="state" id="state" onChange={this.handleInputChange} value={this.state.state} required data-description="select a state or province">
							</select>
						</div>
					</div>

					<div class="form-group row">
						<label for="phone" class="d-none d-sm-inline col-sm-3 control-label text-right">Phone Number</label>

						<div class="col-sm-6">
							<input type="text" class="form-control string" disabled={this.state.loading} name="phone" id="phone" value={this.state.phone} onChange={this.handleInputChange} placeholder="Phone Number" maxlength="175" data-type="phone number" data-description="enter a phone number" required />
						</div>
					</div>

					<div class="form-group row">
						<div class="col-12">
							<span class="text-nowrap">
								<input type="checkbox" disabled={this.state.loading} id="agree-policy" name="agree-policy" value="yes" onChange={this.handleInputChange} required style={{ margin: "5px" }} data-description="agree to the privacy policy and terms of use." />
								<label for="agree-policy">I agree to GreatLeaps's <Link to="/legal/terms-of-use" target="_blank">Terms of Use</Link> and <Link to="/legal/privacy-policy" target="_blank">Privacy Policy</Link>.</label>
							</span>
						</div>
					</div>

					<button type="submit" id="sign-up-button" class="btn btn-secondary btn-lg" disabled={this.state.loading}>
						
						{this.state.loading ? <ClipLoader
							size={20}
							color={"#123abc"}
							loading={this.state.loading}
							/> : "Create Account"}
					</button>
				</form>

			</React.Fragment>
		)
	}

}

export default SignUp;
